export default () => ({
  formDisplayed: false,

  showForm() {
    this.formDisplayed = true;
  },
});
